import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'nationality_3'

export const dataPointDefinition = {
  retracedId: 'nationality_3',
  name: 'Nationality #3',
  description:
    'Indicate the nationality representing the 3rd greatest proportion of workers and supervisors in the facility (whether local or foreign)',
  meta: {
    slcpMeta: {
      key: 'fp-nl-3',
      number: 'FP-NAT-8',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: 'national',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'national',
      name: 'national',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['national'],
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-nl-3', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27890,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
